"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mark_1 = require("./mark");
const colorPattern = /^#[0-9a-f]{6}$/;
class TextColor extends mark_1.Mark {
    constructor(color) {
        super('textColor');
        this.color = color;
        if (!colorPattern.test(color)) {
            throw new Error(`Color ${color} does not match ^#[0-9a-f]{6}$`);
        }
    }
    toJSON() {
        return {
            type: this.type,
            attrs: {
                color: this.color
            }
        };
    }
}
exports.TextColor = TextColor;
//# sourceMappingURL=text-color.js.map